export const currencies = ['USD', 'CAN', 'EUR'];
